export default __webpack_public_path__ + "static/media/client4.f3acb1da.png";